import React from 'react'
import '../Css/Home.css'
import icon_img from '../Assets/footer_img_2.png'
const Footer = () => {
    return (
        <div id="Footer">
            <div className="container">
                <img src={icon_img} alt="" />
            </div>
        </div>
    )
}

export default Footer